import { LanguageService } from 'src/app/services';
import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, Input, ViewChild } from '@angular/core';

import { AuthService } from 'src/app/auth';

@Component({
  selector: 'app-usersnap',
  templateUrl: './usersnap.component.html',
})
export class UsersnapComponent implements AfterViewInit {
  @Input()
  globalApiKey = 'af717ea0-8416-41f2-ab39-282736025f93';

  @Input()
  userApiKey = 'cea1a0ae-0c75-4452-85a5-73c3f01d68f1';

  @ViewChild('script') script: ElementRef | null = null;
  window: Window;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private authService: AuthService,
    private languageService: LanguageService
  ) {
    this.window = this.document.defaultView!;
  }

  ngAfterViewInit() {
    this.convertToScript();
  }

  convertToScript() {
    this.window.onUsersnapCXLoad = (api: any) => {
      const user = this.authService.userInfo;
      const currentLanguage = this.languageService.getCurrentLanguage();

      api.init({
        custom: {
          subject: user.sub,
          language: currentLanguage,
        },
        user: {
          userId: user.sub,
          email: user.email,
        },
      });

      api.show(this.userApiKey);
    };

    var script = document.createElement('script');
    script.defer = false;
    script.type = 'text/javascript';
    script.src = `https://widget.usersnap.com/global/load/${this.globalApiKey}?onload=onUsersnapCXLoad`;

    var element = this.script?.nativeElement;
    var parent = element.parentElement;
    parent.parentElement.replaceChild(script, parent);
  }
}
